module.exports = __webpack_public_path__ + "static/media/ribcage.fe8ee77c.ogg";